/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TBuyPackageModel = IModel<IBuyPackageRequest, TBuyPackageResponse>;

export interface IBuyPackageRequest {
  /** Id рекомендованного пакета, который покупает пользователь **/
  packageId: number;
  /** Нужно ли автоматически продлять пакет **/
  autoProlong?: boolean | null;
  /** Ids полигонов на которые формируется рекомендованный пакет **/
  polygonIds?: number[] | null;
  /** проведение платежа с холдированием **/
  needHold?: boolean | null;
}

export type TBuyPackageResponse = IBuyPackageResponse200 | IBuyPackageResponse400;

export interface IBuyPackageResponse200 extends IModelResponse<IBuyPackageResponse> {
  statusCode: 200;
}

export interface IBuyPackageResponse400 extends IModelResponse<IBuyPackageResponseError> {
  statusCode: 400;
}

export interface IBuyPackageResponse {
  /** Состояние оплаты пакета () **/
  isPaid?: boolean | null;
  /** Номер активированного пакета **/
  servicePackageId?: number | null;
  /** Сообщение в случаи ошибки **/
  message?: string | null;
  /** Код ответа **/
  code?: ECode | null;
}

export interface IBuyPackageResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IBuyPackageResponse | IBuyPackageResponseError;

export enum ECode {
  /** Пакет добавлен и куплен **/
  Ok = 'Ok',
  /** Недостаточно денег для покупки пакета **/
  NotEnoughMoney = 'NotEnoughMoney',
  /** Пользователь не авторизован **/
  NotAuthorised = 'NotAuthorised',
  /** Услуга не доступна **/
  TariffNotAvailable = 'TariffNotAvailable',
  /** Не выбраны услуги в пакете **/
  ServicesNotSelected = 'ServicesNotSelected',
  /** Общая ошибка **/
  Error = 'Error',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IBuyPackageResponse): TResponse200;
  400(response: IBuyPackageResponseError): TResponse400;
}
